import { MouseEvent, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import { FaUndoAlt as ReactivateIcon } from 'react-icons/fa'

import { Alert } from '@core/gateways'
import { AdministracaoService } from '@core/services'
import { UnexpectedError } from '@core/models/errors'
import { useModal } from '@presentation/hooks'
import { ActionButton } from '@presentation/components/molecules'
import { Modal } from '@presentation/components/organisms'
import { ModalProps } from '@presentation/types/components/organisms'
import { ReactivateModalProps } from '@presentation/types/components/templates'

const ReactivateModal: React.FC<ReactivateModalProps> = ({
  id,
  path,
  nameForTitle,
  onReactivate,
  dataKeyForDescription = 'nome'
}) => {
  const { isOpen, openModal, closeModal } = useModal()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [data, setData] = useState<any>()

  useEffect(() => {
    if (isOpen) {
      const loadData = async () => {
        try {
          const data = await AdministracaoService.loadOne({ id, path })
          setData(data)
        } catch (error) {
          onError(error as Error)
        }
      }
      void loadData()
    }
  }, [isOpen])

  const onSuccess = () => {
    closeModal()
    if (onReactivate) {
      onReactivate()
    }
    Alert.callSuccess({
      title: 'Reativado com Sucesso'
    })
  }

  const onError = (error: Error) => {
    closeModal()
    Alert.callError({
      title: 'Falha na Reativação',
      description: error.message
    })
  }

  const onConfirm = async (event: MouseEvent<HTMLButtonElement>) => {
    try {
      setIsSubmitting(true)
      await AdministracaoService.reactivate({
        id,
        path
      })
      onSuccess()
      setIsSubmitting(false)
    } catch (error) {
      if (error instanceof UnexpectedError) {
        onError(error)
      }
    }
  }

  const buttonActions = [
    <Button variant="success" onClick={onConfirm} disabled={isSubmitting}>
      Confirmar
    </Button>
  ]
  const configs: ModalProps = {
    isOpen,
    icon: <ReactivateIcon />,
    title: `Reativação de ${nameForTitle}`,
    description: `Tem certeza de que deseja reativar o item '${
      data ? data[dataKeyForDescription] : ''
    }' ?`,
    actions: buttonActions,
    size: 'sm',
    onClose: closeModal
  }

  return (
    <>
      <ActionButton type="reactivate" onClick={openModal} />
      <Modal {...configs}></Modal>
    </>
  )
}

export default ReactivateModal
